import React, {useCallback, useContext, useState} from "react";
import {WizardContext} from "../Wizard";
import {CHANGE_OPTION_QUANTITY_DATA} from "../../WizardConstants";

export function WizardFormQuantityInput({ data }) {
    const { dispatch } = useContext(WizardContext);
    const [quantity, setQuantity] = useState("")
    const onChange = useCallback((e) => {
            const value = e.target.value
            const numberRegex = new RegExp(/[^0-9]/g)
            if(!numberRegex.test(value)) {
                setQuantity(Number(value) ? Number(value) : value)
                dispatch({type: CHANGE_OPTION_QUANTITY_DATA, dataName: e.target.name, optionValue: value})
            }else {
                return false;
            }
        },
    [dispatch],
    );
    return (
        <div className="form-group">
            <input type="text" className="form-control form-control-solid form-control-lg"
                   name={data.name} placeholder={data.name} value={quantity}
                   onChange={onChange}/>
        </div>
    )
}

